import { render, staticRenderFns } from "./SithMesPrdZpp1Task.vue?vue&type=template&id=487ee8bc&"
import script from "./SithMesPrdZpp1Task.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdZpp1Task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports